export async function fetchCardPortfolio() {
  const response = await fetch('/card_portfolio.json');

  if (!response.ok) {
    throw new Error(`Failed to fetch card portfolio: ${response.status}`);
  }

  return response.json();
}
